/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from "react";


import Meta from "gatsby-theme-carbon/src/components/Meta";
import LeftNav from "gatsby-theme-carbon/src/components/LeftNav";
import Header from "gatsby-theme-carbon/src/components/Header";
import { Switcher } from "../../components/Switcher";
import Container from "gatsby-theme-carbon/src/components/Container";
import useMetadata from "gatsby-theme-carbon/src/util/hooks/useMetadata";
import Footer from "./Footer";

import "gatsby-theme-carbon/src/styles/index.scss";
import { layout } from "../../styles/Layout.module.scss";

const Layout = ({
  children,
  homepage,
  theme,
  titleType,
  pageTitle,
  pageDescription,
  pageKeywords,
  hideNavbar  = false
}) => {
  const is404 = children.key === null;
  const { isSwitcherEnabled } = useMetadata();

  useEffect(() => {
    // eslint-disable-next-line global-require
   require("smooth-scroll")('a[href*="#"]', {
      speed: 400,
      durationMin: 250,
      durationMax: 700,
      easing: "easeInOutCubic",
      clip: true,
      offset: 48,
    });
  }, []);

  return (
    <div className={layout}>
      <Meta
        titleType={titleType}
        pageTitle={pageTitle}
        pageDescription={pageDescription}
        pageKeywords={pageKeywords}
      />
      <Header isSwitcherEnabled={isSwitcherEnabled} />
      {isSwitcherEnabled && <Switcher />}
      <Container homepage={homepage} theme={theme}>
        <main>
        {!hideNavbar && <LeftNav homepage={homepage} is404Page={is404} theme={theme} />}
          <div  id="main-content">
            {children}
          </div>
          </main>
        <Footer />
      </Container>
    </div>
  );
};

export default Layout;
